import React from "react";
import { render } from "react-dom";
import Application from "@gcm/components/core/Application";

render(
  <Application />,
  document.getElementById("root")
);

